// import { Alert } from "react-native";

import { ConfirmationStore } from "~/components/AccountActions";

export const showConfirmation = ({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void;
  onCancel?: () => void;
}) => {
  ConfirmationStore.makeVisible({
    onConfirm,
    onCancel,
  });
};
